module.exports = ".container {\n  margin-bottom: 500px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/charts/column-chart.component.scss
// module id = ./src/app/shared-components/charts/column-chart.component.scss
// module chunks = main